import { adfModelTypeMap } from '../consts/adf-model-type-map-const';
import { IPrivateEndpointMetadata } from './private-endpoint-metadata';
import { getReadonlyControl, synapseResourceIdFormat, synapseResourceIdErrorMessage, getSynapseControls } from './shared-control-metadata';

export const azureSynapsePrivateEndpointMetadata: IPrivateEndpointMetadata = {
    resourceType: 'Microsoft.Synapse/workspaces',
    connectionSuffix: 'privateConnections',
    resourceIdValidator: synapseResourceIdFormat,
    groupIdMetadata: {
        dev: {
            linkedServiceType: adfModelTypeMap.azureSynapseArtifacts.linkedServiceType,
            groupId: 'dev',
            iconClass: 'svg-i-100x100-AzureSynapse',
            displayName: stringResources.AzureSynapseAnalyticsArtifacts,
            controls: {
                creationControls: getSynapseControls(),
                readonlyControls: getReadonlyControl(synapseResourceIdFormat, synapseResourceIdErrorMessage)
            }
        }
    }
};
